// import Vue from 'vue';
// import VueRouter from 'vue-router';
Vue.use(VueRouter);

const Rectify = () => import('@/pages/rectify/views/Rectify.vue')
const Passenger = () => import('@/pages/rectify/views/Passenger.vue')
const PrivacyDeal = () => import('@/pages/rectify/views/privacyDeal.vue')
const ServeDeal = () => import('@/pages/rectify/views/serveDeal.vue')
const AboutUs = () => import('@/pages/rectify/views/AboutUs.vue')
const DownPage = () => import('@/pages/rectify/views/DownPage.vue')
const TourTemplate = () => import('@/pages/rectify/views/TourTemplate.vue')
const EditTemplate = () => import('@/pages/rectify/views/EditTemplate.vue')
const Share = () => import('@/pages/rectify/views/Share.vue')
const Brochure=()=>import('@/pages/rectify/views/Brochure.vue')


const routes = [
  {
    path: '/',
    component: Rectify,
  },
  {
    path: '/rectify',
    component: Rectify,
  },
  {
    path: '/passenger',
    component: Passenger,
  },
  {
    path: '/privacyDeal',
    component: PrivacyDeal,
  },
  {
    path: '/serveDeal',
    component: ServeDeal,
  },
  {
    path: '/aboutUs',
    component: AboutUs,
  },
  {
    path: '/downpage',
    component: DownPage,
  },
  {
    path: '/tourtemplate',
    component: TourTemplate,
  },
  {
    path: '/edittemplate',
    component: EditTemplate,
  },
  {
    path: '/share',
    component: Share,
  },
  {
    path:'/brochure',
    component:Brochure
  }
]

const router = new VueRouter({
  routes
})

export default router
